import Footer from "./footer";
import Audio from "@/components/Audio";
import ClientOnly from "@/components/ClientOnly";
import Ad from "@/components/Ads/Ad";
import AdBar from "@/components/Ads/AdBar";
import Socials from "@/components/common/Socials";
import Navbar from "./navbar";
import { useUser } from "../contexts/user";
import Scrobble from "../utils/scrobble";
import UserMenu from "./user-menu";
import Mailchimp from "./mailchimp";
import Banner from "./banner";
import Hornraiser from "./Hornraiser";

function Layout({ children }) {
  const { isAuthenticated } = useUser();
  return (
    <>
      <ClientOnly>
        <Audio />
        {isAuthenticated && <UserMenu />}
        {isAuthenticated && <Scrobble />}
      </ClientOnly>
      <Navbar />
      <Hornraiser />
          <Banner />
     <main style={{ marginTop: '120px' }}>
       <Ad adType="banner" id="banner-ad" />
        {children}
      </main>
        <div className="container">
          <AdBar />
          <Socials />
          <Mailchimp />
        </div>
      <div role="alert" className="text-center alert alert-dark">
        <strong>
          For underwriting information, please e-mail{" "}
          <a
            className="alert-link"
            href="mailto:advertise@texasstudentmedia.com"
          >
            advertise@texasstudentmedia.com
          </a>
          .
        </strong>
      </div>
      <Footer />
    </>
  );
}

export default Layout;
